import { render, staticRenderFns } from "./bi-button.vue?vue&type=template&id=5b66196f&scoped=true"
import script from "./bi-button.vue?vue&type=script&lang=js"
export * from "./bi-button.vue?vue&type=script&lang=js"
import style0 from "./bi-button.vue?vue&type=style&index=0&id=5b66196f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66196f",
  null
  
)

export default component.exports